module.exports = __webpack_public_path__ + "static/media/whatsapp.6a33e5ef.svg";